<template>
	<UiModalMobile
		v-model="modelValue"
		class="modal__mobile"
		:titleBtnSave="'Сохранить'"
		:isDontNeedCloseWhenSave="true"
		@save="saveHandler"
		height="none"
		min-height-body="unset"
		maxHeight="fit-content"
		:is-loading-btn-save="props.isLoading"
		:z-index="zIndex"
	>
		<div class="wrapper">
			<CommonInputSpecialInput
				v-model="text"
				:is-need-always-visible-input="true"
				:label="getLabel"
				:is-need-change-btn="false"
				btn-title="Сохранить"
				@clickBtn="saveHandler"
			/>
		</div>
	</UiModalMobile>
</template>

<script setup lang="ts">
	import { VALIDATE_RULES, validator } from '~/helpers/validate';
	import type { IDriverRequestsItem } from '~~/shared/interfaces/driverRequests';
	import { TClientType } from '~~/shared/interfaces/storekeeperClient';

	const emits = defineEmits(['save']);
	const modelValue = defineModel('modelValue', { required: true, type: Boolean });
	const props = withDefaults(
		defineProps<{
			currentCargo: IDriverRequestsItem;
			isLoading?: boolean;
			zIndex?: number;
			typeClients: TClientType;
		}>(),
		{}
	);

	const text = ref<string>('');

	const errorField = ref({
		text: { status: false, msg: '' }
	});

	const getLabel = computed(() => {
		if (props.typeClients === TClientType.Sender) {
			return 'Создать отправителя';
		} else {
			return 'Создать получателя';
		}
	});

	const clearError = (type: string) => {
		errorField.value = { ...errorField.value, [type]: { status: false } };
	};

	const validateHandler = () => {
		const arrayRules: Array<{
			field: string;
			value: string | null;
			rules: VALIDATE_RULES[];
		}> = [{ field: 'text', value: text.value, rules: [VALIDATE_RULES.required] }];
		arrayRules.forEach((item) => {
			errorField.value = { ...errorField.value, [item.field]: validator(item.value, item.rules)[0] };
		});
	};

	const saveHandler = () => {
		validateHandler();
		if (!Object.values(errorField.value).find((item) => item.status)) {
			emits('save', {
				name: text.value
			});
		}
	};
</script>

<style scoped lang="scss">
	.modal__mobile {
		display: flex;
		flex-direction: column;

		.ui-select__item {
			display: flex;
			align-items: center;

			.icon {
				margin-right: 5px;
			}
		}

		.label-select {
			margin-left: auto;
		}

		.upper-limit-clue {
			max-width: 300px;
			@media (max-width: $sm) {
				max-width: 200px;
			}
		}

		.input__secret {
			display: flex;
			flex-direction: column;
			gap: 8px;
			margin-bottom: -10px;
		}

		.wrapper {
			display: flex;
			flex-direction: column;
			overflow: auto;
			gap: 17px;
			padding-right: 10px;
			margin-right: -10px;

			.switch-wrapper {
				margin-top: 0px;
				display: flex;
				align-items: center;
				gap: 14px;
			}
		}
	}
</style>
